/**
 * Created by anthony on 7/8/14.
 */
var schoolAddendumModel = angular.module('schoolAddendumModel', ['schoolModel']);
schoolAddendumModel.factory('SchoolAddendumModelFactory', function(ApplicationService, RestService, authServiceFactory, SchoolModelFactory){
    var SchoolAddendumModel = function(){
        this.endpoint = '/SchoolAddendum';
        this.primaryKey = 'recordID';
    }
    SchoolAddendumModel.prototype = new SchoolModelFactory();
    SchoolAddendumModel.prototype.parent = SchoolModelFactory.prototype;
    SchoolAddendumModel.prototype.resolveData = function(schoolID)
    {
        var parent = this;
        return this.parent.resolveData.apply(this, arguments).then(function(data)
        {
            parent.data = data[0].data;
        });

    }
    SchoolAddendumModel.prototype.new = function()
    {
        var schoolID = this.getSchoolID();
        var letter = {schoolID: schoolID, active: 1, approved: 0, fromName: '', message: '', replyTo: '', subject: '', deleted: 0};
        return letter;//(this.data.push(letter)) - 1;

    }
    return SchoolAddendumModel;
});


schoolAddendumModel.service('SchoolAddendumModelService', function(SchoolAddendumModelFactory){
    var schoolModel = new SchoolAddendumModelFactory();
    return schoolModel;
});


